import {
  FormFieldSchema,
  FormFieldType,
} from "@app/components/forms/types/schema";
import { passwordValidation } from "@app/utils/validation";

export const ChangePasswordSchema: FormFieldSchema[] = [
  {
    type: FormFieldType.Password,
    id: "password",
    label: "비밀번호",
    placeholder: "비밀번호를 입력해주세요",
    validationFunction: (value) => passwordValidation.test(value),
    behavior: {
      required: true,
    },
  },
  {
    type: FormFieldType.Password,
    id: "passwordConfirm",
    label: "비밀번호 확인",
    placeholder: "비밀번호를 한번 더 입력해주세요",
    validationFunction: (value) => passwordValidation.test(value),
    behavior: {
      required: true,
    },
  },
];
